// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "home" + "." + "95259fd7a800fcef27fc" + ".css";
};